import { browser } from '$app/environment';
import { DeviceInfo } from './device-info';

//@ts-expect-error: This concept does not exist on the server, so to fail fast we return undefined.
export const deviceInfo: DeviceInfo = browser ? new DeviceInfo() : undefined;
